import { jsx as s } from "react/jsx-runtime";
import { createContext as h, forwardRef as r, useContext as b, useState as O, useCallback as C, useMemo as T } from "react";
import { faXmark as I } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon as z } from "@fortawesome/react-fontawesome";
import * as a from "@radix-ui/react-dialog";
import { Button as B } from "../button/Button.js";
import { twMerge as n } from "tailwind-merge";
const P = a.Trigger, R = a.Portal, X = a.Close, f = h({}), k = ({
  defaultOpen: o,
  open: e,
  onOpenChange: t,
  children: l,
  ...i
}) => {
  const [c, w] = O(!!e || o), p = typeof e < "u" ? e : c, m = C(
    (g) => {
      t == null || t(g), w(g);
    },
    [t]
  ), d = T(() => ({ open: p, setOpen: m }), [p, m]);
  return /* @__PURE__ */ s(a.Root, { open: d.open, onOpenChange: d.setOpen, ...i, children: /* @__PURE__ */ s(f.Provider, { value: d, children: l }) });
}, H = r(
  ({ className: o, variant: e = "none", ...t }, l) => /* @__PURE__ */ s(
    a.Content,
    {
      ref: l,
      className: n(
        e === "fullscreen" && "inset-0 h-[100vh] w-[100vw]",
        e === "none" && "radix-state-open:animate-dialogIn radix-state-closed:animate-dialogOut left-[50%] top-[50%] flex max-h-[85vh] w-[90vw] max-w-[500px] -translate-x-1/2 -translate-y-1/2 flex-col gap-4 overflow-y-auto rounded-xl p-6 shadow-xl focus:outline-none",
        o,
        "z-pentOutermost fixed bg-white"
      ),
      onOpenAutoFocus: (i) => {
        var c;
        i.preventDefault(), (c = i.target) == null || c.focus();
      },
      ...t
    }
  )
), u = r(
  ({ className: o, children: e, "aria-label": t, ...l }, i) => /* @__PURE__ */ s(
    a.Close,
    {
      ref: i,
      className: n("z-pentOutermost absolute right-4 top-4", o),
      asChild: !0,
      ...l,
      children: /* @__PURE__ */ s(
        B,
        {
          variant: "transparent",
          shape: "square",
          color: "neutral",
          "aria-label": t ?? "Close",
          children: e || /* @__PURE__ */ s(z, { size: "lg", icon: I, className: "text-gray-500" })
        }
      )
    }
  )
);
u.displayName = a.DialogClose.displayName;
const x = r(
  ({ className: o, ...e }, t) => /* @__PURE__ */ s("div", { ref: t, className: n("flex flex-col gap-4", o), ...e })
);
x.displayName = "DialogBody";
const y = r(
  ({ className: o, ...e }, t) => /* @__PURE__ */ s(
    "div",
    {
      ref: t,
      className: n("flex flex-col items-start justify-center gap-1", o),
      ...e
    }
  )
);
y.displayName = "DialogHeader";
const D = r(
  ({ className: o, children: e, ...t }, l) => /* @__PURE__ */ s(
    a.Title,
    {
      ref: l,
      className: n("text-lg font-medium leading-7 text-gray-900", o),
      ...t,
      children: e
    }
  )
);
D.displayName = a.DialogTitle.displayName;
const N = r(
  ({ className: o, children: e, ...t }, l) => /* @__PURE__ */ s(
    a.Description,
    {
      ref: l,
      className: n("text-sm text-gray-600", o),
      ...t,
      children: e
    }
  )
);
N.displayName = a.DialogDescription.displayName;
const v = r(
  ({ className: o, ...e }, t) => {
    const { open: l } = b(f);
    return /* @__PURE__ */ s(
      "div",
      {
        ref: t,
        "data-testid": "dialog-overlay",
        className: n(
          "z-pentOutermost pointer-events-auto fixed inset-0 bg-black bg-opacity-50",
          l ? "animate-fadeIn" : "animate-fadeOut",
          o
        ),
        ...e
      }
    );
  }
);
v.displayName = a.DialogOverlay.displayName;
const E = k, G = y, J = x, K = H, L = u, Q = P, U = R, V = v, W = D, Y = N, Z = a.Close;
export {
  J as Body,
  Z as Cancel,
  L as Close,
  K as Content,
  Y as Description,
  x as DialogBody,
  X as DialogCancel,
  u as DialogClose,
  H as DialogContent,
  y as DialogHeader,
  v as DialogOverlay,
  R as DialogPortal,
  k as DialogRoot,
  P as DialogTrigger,
  G as Header,
  V as Overlay,
  U as Portal,
  E as Root,
  W as Title,
  Q as Trigger
};
